import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamActions, IThunkGetActTeamsShowAll } from '../types';

const onGetActTeamsShowAll: IThunkGetActTeamsShowAll = thunk(
  async ({ setActTeamsShowAll }: Actions<IActTeamActions>, { clinicId }) => {
    const { data } = await api.actTeam.getClinicActTeams(clinicId, {
      pageNumber: 1,
      pageSize: 5000,
      showAll: true,
    });
    setActTeamsShowAll(data.items.filter(item => !item.isArchived));
  },
);

export default onGetActTeamsShowAll;
